import React, { useState, useEffect, useCallback } from "react";
import { CheckCircle, Trash2, FileCheck } from "lucide-react";
import CustomInput from "./common/CustomInput";
import CustomHeading from "./common/CustomHeading";
import Button from "./common/Button";
import CustomSelect from "./common/CustomSelect";
import Loader from '../../../../../presentationals/Loader/Loader.component'
import {
  saveRecommendationSection,
  
  saveRecommendationSectionNew,
  getRecommendationSectionDetails,
  saveCommitteeDecisionNew,

  SaveCreditLineRecommendationLoanUtility,
  SaveCreditLineRecommendationProcessingFees,
  SaveCreditLineRecommendationSubvention,
  GetCreditLineRecommendationSubvention,
  GetListCreditLineSubvention,
  getCommitteeStatusByUseId,
  SaveCommitteeStatusByUseId
} from "../ActionCreator";


const grid = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr",
  gap: "20px",
};

const tableBase = {
  width: "100%",
  borderCollapse: "separate",
  borderSpacing: "0 4px",
  fontSize: "13px",
};
const th = {
  padding: "11px 14px",
  textAlign: "left",
  fontWeight: "600",
  color: "#334155",
  fontSize: "12px",
  background: "#f1f5f9",
  borderBottom: "1.5px solid #cbd5e1",
  whiteSpace: "nowrap",
};
const td = { padding: "10px 14px", color: "#0f172a", fontSize: "12px" };
const addBtn = {
  background: "#024e5a",
  color: "#fff",
  border: "none",
  borderRadius: "10px",
  padding: "8px 16px",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all 0.15s ease",
  outline: "none",
};

const NinthSection = ({
  allDetail,
  initialData,
  showPopup,
  onRefresh,
  initialDataFirst,
  admin,
  productType,
}) => {
  const [loader, setLoader] = useState(false)
  const isRecDisabled = admin?.emailId !== "SuperUser" && admin?.department !== "CREDIT";
  const [form, setForm] = useState({
    riskAssessmentSummary: "",
    riskRating: "",
    keyStrengths: "",
    riskMitigants: "",
    keyConcerns: "",
    loanAmountFinal: "",
    roiPercentage: "",
    penalInterest: "",
    loanCycle: "",
    tenureLoan: "",
    sanctionTermsAndConditions: [],
    recommendation: "",
    rationale: "",
    preparedBy: "",
    preparedDate: "",
    reviewedBy: "",
    reviewedDate: "",
  });

  const [additionalSanction, setAdditionalSanction] = useState({
    processingFeePercentage: "",
    disbursalDays: "",
    subventionPct: "",
    tenorDays: "",
  });

  const [recommendation, setRecommendation] = useState("");
  const [obligationRows, setObligationRows] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);
  const [subventionPrograms, setSubventionPrograms] = useState([]);
  const [selectedProgramId, setSelectedProgramId] = useState("custom");
  const [committeeModal, setCommitteeModal] = useState(false);
  const [committeeDecision, setCommitteeDecision] = useState("");
  const [committeeComment, setCommitteeComment] = useState("");
  const [committeeStatus, setcommitteeStatus] = useState("");
  const [committeeDetails, setCommitteeDetails] = useState(null);
  const [productDataModal, setProductDataModal] = useState(false);
  const [productData, setProductData] = useState(null);
  const [productDataLoading, setProductDataLoading] = useState(false);

  const [assignmentPopup, setAssignmentPopup] = useState({ show: false, department: "", data: {} });
  const [assignmentForm, setAssignmentForm] = useState({ department: "", assignedTo: "", comment: "", status: "completed" });
  const [assignmentDepartments, setAssignmentDepartments] = useState({});
  const [assignmentSubmitted, setAssignmentSubmitted] = useState(false);
  const [assignmentSuccess, setAssignmentSuccess] = useState(null);

  

  const handleOpenOpsAssignment = () => {
    const keys = Object.keys(assignmentDepartments);
    const opsKey = keys.find(k => k.toLowerCase().includes("operation") || k.toLowerCase().includes("ops")) || "Operation";
    setAssignmentForm({ department: opsKey, assignedTo: "", comment: "", status: "completed" });
    setAssignmentPopup({
      show: true,
      department: opsKey,
      data: { userId: allDetail?.userId }
    });
    setAssignmentSubmitted(false);
    setAssignmentSuccess(null);
  };

  const handleOpenCommitteeAssignment = () => {
    const keys = Object.keys(assignmentDepartments);
    const committeeKey = keys.find(k => k.toLowerCase().includes("committee") || k.toLowerCase().includes("comitte")) || "COMMITTEE";
    setAssignmentForm({ department: committeeKey, assignedTo: "", comment: "", status: "completed" });
    setAssignmentPopup({
      show: true,
      department: committeeKey,
      data: { userId: allDetail?.userId }
    });
    setAssignmentSubmitted(false);
    setAssignmentSuccess(null);
  };

  

  // Sync state with parent-supplied initialData
  useEffect(() => {
    if (initialData) {
      const sanctionTerms = initialData.sanctionTermsAndConditions ?? [];
      setForm((prev) => ({
        riskAssessmentSummary: initialData.riskAssessmentSummary ?? prev.riskAssessmentSummary,
        riskRating: initialData.riskRating ?? prev.riskRating,
        keyStrengths: initialData.keyStrengths ?? "",
        riskMitigants: initialData.riskMitigants ?? "",
        keyConcerns: initialData.keyConcerns ?? "",
        // For sanction fields: prefer initialData if saved, else keep whatever getapi already set
        loanAmountFinal: initialData.loanAmountFinal || prev.loanAmountFinal || "",
        roiPercentage: initialData.roiPercentage || prev.roiPercentage || "",
        penalInterest: initialData.penalInterest || prev.penalInterest || "",
        loanCycle: initialData.loanCycle || prev.loanCycle || "",
        tenureLoan: initialData.tenureLoan || prev.tenureLoan || "",
        sanctionTermsAndConditions: sanctionTerms,
        recommendation: initialData.recommendation ?? prev.recommendation,
        rationale: initialData.rationale ?? prev.rationale,
        preparedBy: initialData.preparedBy ?? "",
        preparedDate: initialData.preparedDate ?? "",
        reviewedBy: initialData.reviewedBy ?? "",
        reviewedDate: initialData.reviewedDate ?? "",
      }));
      setAdditionalSanction((prev) => ({
        processingFeePercentage: initialData.processingFeePercentage || prev.processingFeePercentage || "",
        disbursalDays: initialData.disbursalDays || prev.disbursalDays || "",
        subventionPct: initialData.subventionPct || prev.subventionPct || "",
        tenorDays: initialData.tenorDays || prev.tenorDays || "",
      }));
      if (initialData.recommendation) {
        setRecommendation(initialData.recommendation);
      }
      setObligationRows(sanctionTerms);
    }
  }, [initialData]);

  // Fetch Recommendation & Committee details from API
  const fetchRecommendationData = useCallback(() => {
    const loanId = allDetail?.loanId || allDetail?.applicationId || "";
    const userId = allDetail?.userId || "";
    if (!loanId && !userId) return;

    setLoader(true);
    getRecommendationSectionDetails(loanId, userId, (res) => {
      setLoader(false);
      if (res?.status === 200 && res?.data) {
        const d = res.data;
        const rec = d.recommendation || "";
        setForm((prev) => ({
          ...prev,
          riskAssessmentSummary: d.riskAssessmentSummary ?? prev.riskAssessmentSummary,
          riskRating: d.riskRating ?? prev.riskRating,
          recommendation: rec || prev.recommendation,
          rationale: d.rationale ?? d.rationaleForRecommendation ?? prev.rationale,
        }));
        if (rec) {
          setRecommendation(rec);
        }

        const status = d.committeeStatus || d.committeeDecision;
        if (status) {
          setcommitteeStatus(status);
          setCommitteeDecision(status);
          setCommitteeComment(d.comment || d.committeeComment || d.committeeRemark || "");
          setCommitteeDetails({
            comment: d.comment || d.committeeComment || d.committeeRemark || "",
            updatedBy: d.updatedBy || d.empId || "SYSTEM",
            updatedAt: d.updatedAt || "",
          });
        }
      } else {
        getCommitteStatus();
      }
    });
  }, [allDetail]);

  useEffect(() => {
    if (allDetail?.userId || allDetail?.loanId) {
      fetchRecommendationData();
      getapi();
    }
  }, [allDetail?.userId, allDetail?.loanId, fetchRecommendationData]);

  // Re-fetch recommendations when product type changes in FirstSection
  useEffect(() => {
    if (allDetail?.userId && productType) {
      getapi(productType);
    }
  }, [productType]);

  const getCommitteStatus = () => {
    getCommitteeStatusByUseId(allDetail?.userId, callback => {
      setcommitteeStatus(callback?.data?.committeeStatus ?? "");
      setCommitteeDetails(callback?.data ?? null);
    });
  };

  const handleCommitteeDecision = () => {
    if (!committeeDecision) {
      showPopup("Please select Status.");
      return;
    }
    setLoader(true);
    setCommitteeModal(false);
    const loanId = allDetail?.loanId || allDetail?.applicationId || "";
    const userId = allDetail?.userId || "";

    const payload = {
      loanId,
      userId,
      committeeStatus: committeeDecision,
      empId: admin?.emailId || "",
      comment: committeeComment,
    };

    saveCommitteeDecisionNew(payload, (callback) => {
      setLoader(false);
      if (callback?.status === 200 || callback?.success === true) {
        showPopup("Decision Submitted Successfully!");
        fetchRecommendationData();
        getCommitteStatus();
        if (onRefresh) onRefresh();
      } else {
        // Fallback to SaveCommitteeStatusByUseId if needed
        showPopup("Error Submitting Decision!");
      }
    });
  };

  const formatCommitteeTime = (dtStr) => {
    if (!dtStr) return "";
    try {
      const date = new Date(dtStr);
      return date.toLocaleString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
    } catch (e) {
      return dtStr;
    }
  };

  const isCommitteeOrSuper = admin?.emailId === "SuperUser" || admin?.department === "COMMITTEE";
  const showSubmitCAM = isCommitteeOrSuper;
  const committeeStatusNorm = committeeStatus ? committeeStatus.trim().toUpperCase().replace(" ", "_") : "";
  const showSubmitCAMText = committeeStatusNorm && committeeStatusNorm !== "PENDING" && committeeStatusNorm !== "UNDER_QUERY";

  const getapi = (overrideProductType) => {
    const payload = {
      userId: allDetail.userId,
      productType: overrideProductType || productType || initialDataFirst?.product,
      nbfcId: "ATcUsLVH"
    };
    // GetCreditLineRecommendationSubvention(
    //   payload,
    //   (res) => {
    //     if (res?.status === 200 && res?.data) {
    //       const d = res.data;
    //       setAdditionalSanction({
    //         processingFeePercentage: d.processingFeePct ?? "",
    //         disbursalDays: d.disbursalDays ?? "",
    //         subventionPct: d.subventionPct ?? "",
    //         tenorDays: d.tenureDays ?? "",   // API field is tenureDays
    //       });
    //       setForm((prev) => ({
    //         ...prev,
    //         loanAmountFinal: d.loanAmount ?? prev.loanAmountFinal,
    //         roiPercentage: d.normalInterest ?? prev.roiPercentage,
    //         penalInterest: d.penalInterest ?? prev.penalInterest,
    //         loanCycle: d.tenureDays ?? prev.loanCycle,
    //         tenureLoan: d.noOfEmi ?? prev.tenureLoan,
    //       }));
    //     }
    //   },
    //   (err) => {
    //     console.error("Error fetching recommendation", err);
    //   }
    // );
  }

  const handleProgramSelectChange = (e) => {
    const val = e.target.value;
    setSelectedProgramId(val);
    if (val !== "custom") {
      const prog = subventionPrograms.find((p) => String(p.id) === String(val));
      if (prog) {
        setAdditionalSanction((prev) => ({
          ...prev,
          disbursalDays: prog.disbursalDays ?? "",
          subventionPct: prog.subventionPct ?? "",
          tenorDays: prog.tenorDays ?? "",
        }));
      }
    }
  };

  // useEffect(() => {
  //   if (initialDataFirst?.product) {
  //     GetListCreditLineSubvention(
  //       initialDataFirst.product,
  //       (res) => {
  //         if (res?.status == 200 && Array.isArray(res?.data)) {
  //           setSubventionPrograms(res.data);
  //         } else if (Array.isArray(res)) {
  //           setSubventionPrograms(res);
  //         }
  //       },
  //       (err) => {
  //         console.error("Error fetching Subvention programs list", err);
  //       }
  //     );
  //   }
  // }, [initialDataFirst?.product]);

  useEffect(() => {
    if (subventionPrograms.length > 0 && additionalSanction.disbursalDays && additionalSanction.subventionPct) {
      const match = subventionPrograms.find(
        (p) =>
          Number(p.disbursalDays) === Number(additionalSanction.disbursalDays) &&
          Number(p.subventionPct) === Number(additionalSanction.subventionPct)
      );
      if (match) {
        setSelectedProgramId(String(match.id));
      } else {
        setSelectedProgramId("custom");
      }
    }
  }, [subventionPrograms, additionalSanction.disbursalDays, additionalSanction.subventionPct]);

  useEffect(() => {
    const isScfOrDbidOrPid = ["SCF", "DBID", "PID"].includes(String(productType || "").toUpperCase());
    if (isScfOrDbidOrPid && selectedProgramId !== "custom") {
      const normalInterest = Number(form.roiPercentage) || 0;
      const subventionPct = Number(additionalSanction.subventionPct) || 0;
      if (normalInterest > 0) {
        const calculatedCycle = Math.round(subventionPct / (normalInterest / 365));
        setForm((prev) => {
          if (String(prev.loanCycle) !== String(calculatedCycle)) {
            return {
              ...prev,
              loanCycle: calculatedCycle,
            };
          }
          return prev;
        });
        setAdditionalSanction((prev) => {
          if (String(prev.tenorDays) !== String(calculatedCycle)) {
            return {
              ...prev,
              tenorDays: calculatedCycle,
            };
          }
          return prev;
        });
      }
    }
  }, [selectedProgramId, form.roiPercentage, additionalSanction.subventionPct, productType]);

  const handleChange = (e, field) => {
    const val = e.target.value;
    setForm((prev) => ({
      ...prev,
      [field]: val,
    }));
  };

  const handleAdditionalChange = (e, field) => {
    const val = e.target.value;
    setAdditionalSanction((prev) => ({
      ...prev,
      [field]: val,
    }));
  };

  const addObligationRow = () => {
    const updated = [...obligationRows, { Term: "" }];
    setObligationRows(updated);
    setForm((prev) => ({
      ...prev,
      sanctionTermsAndConditions: updated,
    }));
  };

  const handleObligationChange = (index, field, value) => {
    const updated = obligationRows.map((row, i) =>
      i === index ? { ...row, [field]: value } : row
    );
    setObligationRows(updated);
    setForm((prev) => ({
      ...prev,
      sanctionTermsAndConditions: updated,
    }));
  };

  const removeObligationRow = (index) => {
    const updated = obligationRows.filter((_, i) => i !== index);
    setObligationRows(updated);
    setForm((prev) => ({
      ...prev,
      sanctionTermsAndConditions: updated,
    }));
  };

  const handleRecommendation = (val, field = "recommendation") => {
    if (field === "recommendation") {
      setRecommendation(val);
    }
    setForm((prev) => ({
      ...prev,
      [field]: val,
    }));
  };

  const handleSave = () => {
    setBtnLoading(true);
    const loanId = allDetail?.loanId || allDetail?.applicationId || "";
    const userId = allDetail?.userId || "";

    const payload = {
      loanId,
      userId,
      riskAssessmentSummary: form.riskAssessmentSummary,
      riskRating: form.riskRating,
      recommendation: form.recommendation || recommendation,
      rationale: form.rationale,
    };

    saveRecommendationSectionNew(
      payload,
      (res) => {
        setBtnLoading(false);
        if (res?.status === 200 || res?.success === true) {
          showPopup("Recommendation saved successfully");
          if (onRefresh) onRefresh();
        } else {
          // Fallback to legacy save
          showPopup("Error saving Recommendation section");
        }
      },
      (err) => {
        // Fallback to legacy save
       showPopup("Error saving Recommendation section");
      }
    );
  };



  const secBtn = {
    background: "#024e5a",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    padding: "8px 16px",
    fontSize: "12px",
    fontWeight: "600",
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "all 0.15s ease",
    display: "flex",
    alignItems: "center",
    gap: "6px",
  };

  const recOptions = [
    {
      key: "approve",
      label: "Recommendation",
      sub: "Recommend for loan sanction",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <polyline points="9 12 11 14 15 10" />
        </svg>
      ),
      activeStyle: { background: "#e8f5e9", border: "2px solid #43a047", color: "#2e7d32" },
      defaultStyle: { background: "#fff", border: "2px solid #e0e0e0", color: "#3a3a3a" },
      iconColor: "#43a047",
    },
    {
      key: "defer",
      label: "DEFER",
      sub: "Need additional information/clarification",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="12" y1="8" x2="12" y2="12" />
          <line x1="12" y1="16" x2="12.01" y2="16" />
        </svg>
      ),
      activeStyle: { background: "#fff8e1", border: "2px solid #f9a825", color: "#f57f17" },
      defaultStyle: { background: "#fff", border: "2px solid #e0e0e0", color: "#3a3a3a" },
      iconColor: "#f9a825",
    },
    {
      key: "reject",
      label: "REJECT",
      sub: "Not recommended for loan sanction",
      icon: (
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10" />
          <line x1="15" y1="9" x2="9" y2="15" />
          <line x1="9" y1="9" x2="15" y2="15" />
        </svg>
      ),
      activeStyle: { background: "#ffebee", border: "2px solid #e53935", color: "#c62828" },
      defaultStyle: { background: "#fff", border: "2px solid #e0e0e0", color: "#3a3a3a" },
      iconColor: "#e53935",
    },
  ];

  // const filteredPrograms = form.loanCycle
  //   ? subventionPrograms.filter((p) => Number(p.tenorDays) === Number(form.loanCycle))
  //   : subventionPrograms;
   const filteredPrograms=subventionPrograms;

  return (
    <div style={{ marginTop: '12px', background: "#F9FAFB" }}>
      {
        loader ? <Loader /> : ""
      }
      <CustomHeading
        title="Credit Manager's Observation & Recommendation"
        subtitle="Final assessment and recommendation"
        buttonText="Pending"
        icon={CheckCircle}
        buttonColor="#F49F28"
        borderColor="#E84E4E"
        background="#E84E4E36"
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <Button
          title="Save Data"
          onClick={handleSave}
          btnLoading={btnLoading}
        />
      </div>

      {/* ── Overall Risk Assessment ── */}
      <div style={card}>
        <h5 style={{ ...sectionTitle, color: "#e91e8c", marginBottom: "16px" }}>Overall Risk Assessment</h5>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Risk Assessment Summary</label>
          <textarea
            placeholder="Provide a comprehensive risk assessment based on all parameters evaluated..."
            value={form.riskAssessmentSummary}
            onChange={(e) => handleChange(e, "riskAssessmentSummary")}
            rows={4}
            style={textarea}
          />
        </div>

        <div>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Risk Rating</label>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px", marginTop: "8px" }}>
            {[
              { key: "low", dot: "#43a047", title: "Low Risk", sub: "All parameters meet or exceed policy norms" },
              { key: "moderate", dot: "#f9a825", title: "Moderate Risk", sub: "Some deviations with acceptable mitigants" },
              { key: "high", dot: "#e53935", title: "High Risk", sub: "Multiple parameters below norm high exposure" },
            ].map((r) => {
              const isActive = form.riskRating === r.key;
              return (
                <div
                  key={r.key}
                  onClick={() => handleRecommendation(r.key, "riskRating")}
                  style={{
                    border: isActive ? `2px solid ${r.dot}` : "1px solid #E0E0E0",
                    borderRadius: "10px",
                    padding: "12px 14px",
                    cursor: "pointer",
                    background: isActive ? "#fafafa" : "#fff",
                    transition: "all 0.15s",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "7px", marginBottom: "4px" }}>
                    <div style={{ width: "10px", height: "10px", borderRadius: "50%", background: r.dot, flexShrink: 0 }} />
                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#0C0B10" }}>{r.title}</span>
                  </div>
                  <p style={{ margin: 0, fontSize: "11px", color: "#686C70", paddingLeft: "17px" }}>{r.sub}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* ── Key Strengths & Risk Mitigants ── */}
      {/* <div style={{ ...card, marginTop: "12px" }}>
        <h5 style={{ ...sectionTitle, color: "#e91e8c", marginBottom: "16px" }}>Key Strengths & Risk Mitigants</h5>

        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Key Strengths</label>
          <textarea
            placeholder="List the key strengths of an applicant (eg. strong cash flow, good credit history, experienced management, Stable business Model etc)..."
            value={form.keyStrengths}
            onChange={(e) => handleChange(e, "keyStrengths")}
            rows={4}
            style={textarea}
          />
        </div>

        <div style={{ marginBottom: "16px" }}>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Risk Mitigants</label>
          <textarea
            placeholder="List the risk mitigation factors (eg. collateral available, guarantor Support, insurance coverage, hedging arrangements, etc)..."
            value={form.riskMitigants}
            onChange={(e) => handleChange(e, "riskMitigants")}
            rows={4}
            style={textarea}
          />
        </div>

        <div>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Key Concerns/ Weakness</label>
          <textarea
            placeholder="List any concerns or weakness identified (eg. low DSCR, industry headwinds, high competition, working capital constraints, etc)..."
            value={form.keyConcerns}
            onChange={(e) => handleChange(e, "keyConcerns")}
            rows={4}
            style={textarea}
          />
        </div>
      </div> */}

     

      {/* ── Sanction Terms & Conditions ── */}
      {/* <div style={{ ...card, marginTop: "12px" }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", marginBottom: '10px' }}>
          <h5 style={{ ...sectionTitle, color: "#e91e8c", marginBottom: "16px" }}>Sanction Terms & Conditions</h5>
          <div>
            <button
              onClick={addObligationRow}
              style={addBtn}
            >
              + Add
            </button>
          </div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={tableBase}>
            <thead>
              <tr>
                {["S.no.", "Terms", "Action"].map((h) => (
                  <th
                    key={h}
                    style={{ ...th, width: h === "Action" ? "60px" : "auto" }}
                  >
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {obligationRows?.map((row, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #F5F5F5" }}>
                  <td style={td}>
                    {index + 1}
                  </td>
                  {["Term"].map((field) => (
                    <td key={field} style={td}>
                      <CustomInput
                        type="text"
                        placeholder=""
                        value={row[field] || ""}
                        onChange={(e) => handleObligationChange(index, field, e.target.value)}
                      />
                    </td>
                  ))}
                  <td style={{ ...td, textAlign: "center" }}>
                    <button
                      onClick={() => removeObligationRow(index)}
                      style={{
                        background: "#e53935",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px",
                        padding: "4px 8px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transition: "all 0.2s",
                      }}
                      title="Delete row"
                    >
                      <Trash2 size={14} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div> */}

      {/* ── Signature Verifications ── */}
      {/* <div style={{ ...card, marginTop: "12px" }}>
        <h5 style={{ ...sectionTitle, color: "#e91e8c", marginBottom: "14px" }}>Signature Verifications</h5>

        <div style={{
          display: "flex", alignItems: "center", gap: "8px",
          background: "#e8f5e9", border: "1px solid #a5d6a7",
          borderRadius: "8px", padding: "10px 14px", marginBottom: "20px",
        }}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#43a047" strokeWidth="2.5" style={{ width: 'auto' }}>
            <circle cx="12" cy="12" r="10" />
            <polyline points="9 12 11 14 15 10" />
          </svg>
          <span style={{ fontSize: "13px", color: "#2e7d32", fontWeight: "500" }}>
            Signature consistency verified across all signed documents.
          </span>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "14px", marginBottom: "14px" }}>
          <div>
            <CustomInput
              label="Prepared by"
              type="text"
              placeholder="Credit Manager Name"
              value={form.preparedBy}
              onChange={(e) => handleChange(e, "preparedBy")}
            />
          </div>
          <div>
            <CustomInput
              label="Date"
              type="date"
              placeholder="dd-mm-yyyy"
              value={form.preparedDate}
              onChange={(e) => handleChange(e, "preparedDate")}
            />
          </div>
          <div>
            <CustomInput
              label="Reviewed By (optional)"
              type="text"
              placeholder="Senior Manager Name"
              value={form.reviewedBy}
              onChange={(e) => handleChange(e, "reviewedBy")}
            />
          </div>
        </div>

        <div style={{ maxWidth: "220px" }}>
          <CustomInput
            label="Reviewed Date (optional)"
            type="date"
            placeholder="dd-mm-yyyy"
            value={form.reviewedDate}
            onChange={(e) => handleChange(e, "reviewedDate")}
          />
        </div>
      </div> */}

      {/* ── Final Recommendations ── */}
      <div style={{ ...card, marginTop: "12px", opacity: isRecDisabled ? 0.85 : 1 }}>
        <h5 style={{ ...sectionTitle, color: "#e91e8c", marginBottom: "16px" }}>Final Recommendations</h5>

        <div style={{ marginBottom: "20px" }}>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Recommendation</label>
          <div style={{ display: "grid", gridTemplateColumns: window.innerWidth > 1200 ? "1fr 1fr 1fr" : "1fr", gap: "12px", marginTop: "8px" }}>
            {recOptions.map((opt) => {
              const currentRec = form.recommendation || recommendation;
              const isActive = currentRec === opt.key;
              const style = isActive ? opt.activeStyle : opt.defaultStyle;
              const iconColor = isActive ? opt.iconColor : "#aaa";
              return (
                <div
                  key={opt.key}
                  onClick={() => handleRecommendation(opt.key, "recommendation")}
                  style={{
                    ...style,
                    borderRadius: "10px",
                    padding: "14px 16px",
                    cursor: "pointer",
                    transition: "all 0.15s",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" }}>
                    <span style={{ color: iconColor, display: "flex" }}>{opt.icon}</span>
                    <span style={{ fontSize: "14px", fontWeight: "700", letterSpacing: "0.3px" }}>{opt.label}</span>
                  </div>
                  <p style={{ margin: 0, fontSize: "11px", color: "#686C70", paddingLeft: "30px" }}>{opt.sub}</p>
                </div>
              );
            })}
          </div>
        </div>

      

        <div>
          <label style={{ fontSize: '14px', fontWeight: 500 }}>Rationale for Recommendation</label>
          <textarea
            placeholder="Provide a detailed reasoning for your recommendation..."
            value={form.rationale}
            onChange={(e) => handleChange(e, "rationale")}
            rows={4}
            style={textarea}
          />
        </div>

        {showSubmitCAM && (
          <button
            style={committeeBtn}
            onClick={() => {
              setCommitteeDecision(committeeStatusNorm || "PENDING");
              setCommitteeComment(committeeDetails?.comment || "");
              setCommitteeModal(true);
            }}
          >
            <FileCheck
              style={{
                width: 14,
                height: 14,
                strokeWidth: "1.8px",
                flexShrink: 0,
              }}
            />
            Final Committee Decision
          </button>
        )}

        {showSubmitCAMText && (
          <div
            style={{
              marginTop: "16px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "12px 16px",
              borderRadius: 8,
              background: committeeStatusNorm === "APPROVED" ? "#ecfdf5" : "#fef2f2",
              border: `1px solid ${committeeStatusNorm === "APPROVED" ? "#10b981" : "#ef4444"}`,
              width: "fit-content",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <i
                className={committeeStatusNorm === "APPROVED" ? "fa fa-check-circle" : "fa fa-times-circle"}
                style={{ fontSize: 20, color: committeeStatusNorm === "APPROVED" ? "#10b981" : "#ef4444" }}
              />
              <div>
                <span style={{ fontSize: 12, color: "#64748b", display: "block" }}>Decision Status</span>
                <strong style={{ fontSize: 15, color: committeeStatusNorm === "APPROVED" ? "#065f46" : "#991b1b" }}>
                  {committeeStatusNorm}
                </strong>
              </div>
            </div>
          </div>
        )}
      </div>

      {committeeModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 9999,
            background: "rgba(15,23,42,0.45)",
            backdropFilter: "blur(4px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "#fff",
              borderRadius: 16,
              padding: "28px 32px",
              maxWidth: 480,
              width: "90%",
              boxShadow: "0 20px 40px rgba(15,23,42,0.15)",
              display: "flex",
              flexDirection: "column",
              gap: 20,
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <h4 style={{ margin: 0, fontSize: 18, fontWeight: 700, color: "#0f172a" }}>
                {committeeStatusNorm === "PENDING" || committeeStatusNorm === "UNDER_QUERY" || !committeeStatusNorm
                  ? "Final Committee Decision"
                  : "Committee Decision Details"}
              </h4>
              <button
                onClick={() => setCommitteeModal(false)}
                style={{
                  background: "none",
                  border: "none",
                  fontSize: 18,
                  color: "#94a3b8",
                  cursor: "pointer",
                  padding: 4,
                }}
              >
                <i className="fa fa-times" />
              </button>
            </div>

            {committeeStatusNorm === "PENDING" || committeeStatusNorm === "UNDER_QUERY" || !committeeStatusNorm ? (
              <>
                <p style={{ margin: 0, fontSize: 13, color: "#64748b", lineHeight: 1.5 }}>
                  Select the final decision for this application and provide supporting comments. This action will update the review status.
                </p>

                {committeeDetails && (
                  <div
                    style={{
                      background: "#f8fafc",
                      border: "1px solid #e2e8f0",
                      borderRadius: 10,
                      padding: "12px 16px",
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                      <span style={{ fontSize: 11, fontWeight: 600, color: "#64748b", textTransform: "uppercase" }}>Current Status</span>
                      <span
                        style={{
                          fontSize: 12,
                          fontWeight: 700,
                          color: committeeStatusNorm === "APPROVED" ? "#10b981" : committeeStatusNorm === "REJECTED" ? "#ef4444" : "#f59e0b",
                          background: committeeStatusNorm === "APPROVED" ? "#ecfdf5" : committeeStatusNorm === "REJECTED" ? "#fef2f2" : "#fef3c7",
                          padding: "2px 8px",
                          borderRadius: 12,
                        }}
                      >
                        {committeeStatusNorm || "PENDING"}
                      </span>
                    </div>

                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                      <div>
                        <span style={{ fontSize: 10, color: "#64748b" }}>Updated By</span>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#334155" }}>
                          {committeeDetails?.updatedBy || "SYSTEM"}
                        </div>
                      </div>
                      <div>
                        <span style={{ fontSize: 10, color: "#64748b" }}>Updated On</span>
                        <div style={{ fontSize: 12, fontWeight: 600, color: "#334155" }}>
                          {formatCommitteeTime(committeeDetails?.updatedAt)}
                        </div>
                      </div>
                    </div>

                    {committeeDetails?.comment && (
                      <div style={{ borderTop: "1px dashed #e2e8f0", paddingTop: 8, marginTop: 4 }}>
                        <span style={{ fontSize: 10, color: "#64748b" }}>Remarks</span>
                        <p style={{ margin: 0, fontSize: 12, color: "#334155", lineHeight: 1.4 }}>
                          {committeeDetails.comment}
                        </p>
                      </div>
                    )}
                  </div>
                )}

                {/* Decision Selector Cards */}
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
                  <button
                    onClick={() => setCommitteeDecision("PENDING")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      padding: "16px 12px",
                      borderRadius: 10,
                      border: `2px solid ${committeeDecision === "PENDING" ? "#d97706" : "#cbd5e1"}`,
                      background: committeeDecision === "PENDING" ? "#fef3c7" : "#fff",
                      color: committeeDecision === "PENDING" ? "#92400e" : "#475569",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: 14,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i className="fa fa-clock-o" style={{ fontSize: 20, color: committeeDecision === "PENDING" ? "#d97706" : "#94a3b8" }} />
                    Pending
                  </button>

                  <button
                    onClick={() => setCommitteeDecision("APPROVED")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      padding: "16px 12px",
                      borderRadius: 10,
                      border: `2px solid ${committeeDecision === "APPROVED" ? "#10b981" : "#cbd5e1"}`,
                      background: committeeDecision === "APPROVED" ? "#ecfdf5" : "#fff",
                      color: committeeDecision === "APPROVED" ? "#065f46" : "#475569",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: 14,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i className="fa fa-check-circle" style={{ fontSize: 20, color: committeeDecision === "APPROVED" ? "#10b981" : "#94a3b8" }} />
                    Approve
                  </button>

                  <button
                    onClick={() => setCommitteeDecision("UNDER_QUERY")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      padding: "16px 12px",
                      borderRadius: 10,
                      border: `2px solid ${committeeDecision === "UNDER_QUERY" ? "#b95f10" : "#cbd5e1"}`,
                      background: committeeDecision === "UNDER_QUERY" ? "#fdf7ec" : "#fff",
                      color: committeeDecision === "UNDER_QUERY" ? "#5f2b06" : "#475569",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: 14,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i className="fa fa-question-circle" style={{ fontSize: 20, color: committeeDecision === "UNDER_QUERY" ? "#b95f10" : "#94a3b8" }} />
                    Under Query
                  </button>

                  <button
                    onClick={() => setCommitteeDecision("REJECTED")}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 8,
                      padding: "16px 12px",
                      borderRadius: 10,
                      border: `2px solid ${committeeDecision === "REJECTED" ? "#ef4444" : "#cbd5e1"}`,
                      background: committeeDecision === "REJECTED" ? "#fef2f2" : "#fff",
                      color: committeeDecision === "REJECTED" ? "#991b1b" : "#475569",
                      cursor: "pointer",
                      fontWeight: 600,
                      fontSize: 14,
                      transition: "all 0.2s ease",
                    }}
                  >
                    <i className="fa fa-times-circle" style={{ fontSize: 20, color: committeeDecision === "REJECTED" ? "#ef4444" : "#94a3b8" }} />
                    Reject
                  </button>
                </div>

                {/* Comment input */}
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#334155" }}>
                    Comment / Remarks
                  </label>
                  <textarea
                    value={committeeComment}
                    onChange={(e) => setCommitteeComment(e.target.value)}
                    placeholder="Enter details about your decision..."
                    style={{
                      width: "100%",
                      minHeight: 80,
                      padding: 10,
                      borderRadius: 8,
                      border: "1px solid #cbd5e1",
                      fontSize: 13,
                      outline: "none",
                      resize: "vertical",
                      fontFamily: "inherit",
                    }}
                  />
                </div>

                {/* Actions */}
                <div style={{ display: "flex", gap: 12, justifyContent: "flex-end", marginTop: 4 }}>
                  <button
                    onClick={() => setCommitteeModal(false)}
                    style={{
                      padding: "8px 18px",
                      borderRadius: 8,
                      border: "1px solid #cbd5e1",
                      background: "#fff",
                      color: "#475569",
                      fontWeight: 600,
                      fontSize: 13,
                      cursor: "pointer",
                    }}
                  >
                    Cancel
                  </button>
                  <button
                    onClick={handleCommitteeDecision}
                    disabled={!committeeDecision}
                    style={{
                      padding: "8px 18px",
                      borderRadius: 8,
                      border: "none",
                      background: !committeeDecision ? "#cbd5e1" : "#024e5a",
                      color: "#fff",
                      fontWeight: 600,
                      fontSize: 13,
                      cursor: !committeeDecision ? "not-allowed" : "pointer",
                    }}
                  >
                    Submit Decision
                  </button>
                </div>
              </>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 16px",
                    borderRadius: 8,
                    background: committeeStatusNorm === "APPROVED" ? "#ecfdf5" : "#fef2f2",
                    border: `1px solid ${committeeStatusNorm === "APPROVED" ? "#10b981" : "#ef4444"}`,
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <i
                      className={committeeStatusNorm === "APPROVED" ? "fa fa-check-circle" : "fa fa-times-circle"}
                      style={{ fontSize: 20, color: committeeStatusNorm === "APPROVED" ? "#10b981" : "#ef4444" }}
                    />
                    <div>
                      <span style={{ fontSize: 12, color: "#64748b", display: "block" }}>Decision Status</span>
                      <strong style={{ fontSize: 15, color: committeeStatusNorm === "APPROVED" ? "#065f46" : "#991b1b" }}>
                        {committeeStatusNorm}
                      </strong>
                    </div>
                  </div>
                </div>

                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                  <div>
                    <span style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Decision By</span>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#334155", marginTop: 4 }}>
                      {committeeDetails?.updatedBy || "SYSTEM"}
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Decided On</span>
                    <div style={{ fontSize: 13, fontWeight: 600, color: "#334155", marginTop: 4 }}>
                      {formatCommitteeTime(committeeDetails?.updatedAt)}
                    </div>
                  </div>
                </div>

                {committeeDetails?.comment && (
                  <div style={{ display: "flex", flexDirection: "column", gap: 6, background: "#f8fafc", padding: 12, borderRadius: 8, border: "1px solid #e2e8f0" }}>
                    <span style={{ fontSize: 11, color: "#64748b", textTransform: "uppercase", fontWeight: 600 }}>Remarks / Comment</span>
                    <p style={{ margin: 0, fontSize: 13, color: "#334155", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>
                      {committeeDetails.comment}
                    </p>
                  </div>
                )}

                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
                  <button
                    onClick={() => setCommitteeModal(false)}
                    style={{
                      padding: "8px 24px",
                      borderRadius: 8,
                      border: "1px solid #cbd5e1",
                      background: "#fff",
                      color: "#475569",
                      fontWeight: 600,
                      fontSize: 13,
                      cursor: "pointer",
                    }}
                  >
                    Close
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      
    </div>
  );
};

// ── Shared styles ──────────────────────────────────────────
const card = {
  background: "rgba(255, 255, 255, 0.95)",
  border: "1px solid #cbd5e1",
  borderRadius: "16px",
  padding: "20px",
  boxShadow: "0 4px 20px -2px rgba(15, 23, 42, 0.04), 0 2px 8px -1px rgba(15, 23, 42, 0.02)",
};
const committeeBtn = {
  background: "#024e5a",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  padding: "10px 20px",
  fontSize: "13px",
  fontWeight: "600",
  cursor: "pointer",
  whiteSpace: "nowrap",
  transition: "all 0.15s ease",
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginTop: "16px",
  width: "fit-content",
};
const sectionTitle = { fontSize: "16px", fontWeight: "600", margin: "0 0 6px 0" };
const textarea = {
  width: "100%",
  border: "1.5px solid #cbd5e1",
  borderRadius: "10px",
  padding: "10px 12px",
  fontSize: "13px",
  color: "#0f172a",
  outline: "none",
  background: "#fff",
  boxSizing: "border-box",
  resize: "vertical",
  minHeight: "90px",
  lineHeight: "1.6",
  fontFamily: "inherit",
  transition: "all 0.15s ease",
};

export default NinthSection;